module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-pl-PL.208dfcf0.jpg";